import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import classNames from "classnames";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { CounterpartyDirectoryViewRow } from "../counterpartyDirectoryViewTypes";
import { CounterpartyManagementDropdown } from "../CounterpartyManagementDropdown";
import { useIsTableReadonly } from "@hooks/useIsReadonlyOrLocked";
import styles from "../DirectoryTable.module.scss";

export const CounterpartyActionsCell: React.FC<
    CellContext<ViewTableFeatures, CounterpartyDirectoryViewRow, string>
> = React.memo(({ row, table }) => {
    const isReadonly = useIsTableReadonly(table);

    if (
        isReadonly ||
        row.original.isNoCounterparty ||
        row.original.isAccountRow ||
        !row.original.counterparty
    ) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell captureClicks>
            <CounterpartyManagementDropdown
                counterparty={row.original.counterparty}
                className={classNames(
                    viewTableStyles.showOnHover,
                    styles.managementDropdown,
                )}
                journalEntryLinesCount={row.original.journalEntryLinesCount}
                hasBillOrInvoiceLinks={
                    (row.original.billCount ?? 0) > 0 ||
                    (row.original.invoiceCount ?? 0) > 0
                }
            />
        </ViewTableCell>
    );
});

CounterpartyActionsCell.displayName = "CounterpartyActionsCell";
